/*
 * Awhi — home hero slideshow (Phase 3).
 * Cross-fade + dots + autoplay. Autoplay pauses on hover, focus, and when
 * the tab is hidden. Single-slide heroes get no dots and no timer.
 *
 * Changed from slide to fade 28/07 (Scott's review). The old build was a
 * scroll-snap track driven by track.scrollLeft, which also needed a cloned
 * first slide to fake an infinite forward loop. Fading makes both redundant:
 * slides are stacked in one grid cell and the index just wraps, so the clone
 * is gone (it was also skipped in the theme editor, which meant the editor
 * and the storefront ran different code paths — they no longer diverge).
 */
(function () {
  'use strict';

  function initHero(root) {
    if (root.dataset.awhiHeroInit) return;
    root.dataset.awhiHeroInit = '1';

    var track = root.querySelector('[data-awhi-hero-track]');
    var dotsWrap = root.querySelector('[data-awhi-hero-dots]');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.children);
    var count = slides.length;
    if (count < 2) {
      if (dotsWrap) dotsWrap.hidden = true;
      // Liquid marks slide 1 active, but a single slide re-rendered by the
      // editor can arrive without it.
      if (slides[0]) slides[0].classList.add('is-active');
      return;
    }

    var delay = parseInt(root.dataset.autoplay, 10) || 0;
    var timer = null;
    var paused = false;
    var index = 0;

    // Trust the markup for the starting slide rather than assuming 0 — the
    // editor re-renders the section on every block edit.
    for (var s = 0; s < count; s++) {
      if (slides[s].classList.contains('is-active')) index = s;
    }

    function goTo(next) {
      index = ((next % count) + count) % count;
      for (var i = 0; i < count; i++) {
        var on = i === index;
        slides[i].classList.toggle('is-active', on);
        if (on) {
          slides[i].removeAttribute('aria-hidden');
        } else {
          slides[i].setAttribute('aria-hidden', 'true');
        }
      }
      syncDots();
    }

    function syncDots() {
      if (!dotsWrap) return;
      var dots = dotsWrap.children;
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === index);
      }
    }

    function tick() {
      if (paused || document.hidden) return;
      goTo(index + 1);
    }

    function startTimer() {
      if (!delay) return;
      stopTimer();
      timer = window.setInterval(tick, delay * 1000);
    }
    function stopTimer() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    if (dotsWrap) {
      dotsWrap.addEventListener('click', function (e) {
        var dot = e.target.closest('[data-dot]');
        if (!dot) return;
        goTo(Number(dot.dataset.dot));
        startTimer();
      });
    }

    root.addEventListener('pointerenter', function () { paused = true; });
    root.addEventListener('pointerleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });

    goTo(index);
    startTimer();
  }

  function initAll() {
    var heroes = document.querySelectorAll('[data-awhi-hero]');
    for (var i = 0; i < heroes.length; i++) initHero(heroes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Theme editor: re-init when the section re-renders.
  document.addEventListener('shopify:section:load', initAll);
})();
